import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { AuthenticationService } from './shared/services/authentication.service';
import moment from 'moment';
import { AuthenticationNumberService } from './shared/services/authentication-number.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './shared/components/loader/loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoaderComponent],
})
export class AppComponent implements OnInit {

  constructor(
    public modalService: NgbModal,
    public router: Router,
    private authenticationService: AuthenticationService,
    private authenticationNumberService: AuthenticationNumberService
  ) { }

  private readonly DATE_TIME_FORMAT = 'HH:mm';
  private now: Date;

  public ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.modalService.dismissAll();
      }
    });

    let isOpen = sessionStorage.getItem("modal-open");
    let nextAuthEvent = sessionStorage.getItem("next-auth-event");
    let username = sessionStorage.getItem("username");
    if (isOpen && isOpen === "true") {
      sessionStorage.removeItem("modal-open");
      this.authenticationService.logout(true);
    }

    if (nextAuthEvent) {
      let nextAuthEventTime = new Date(nextAuthEvent);
      this.now = moment(new Date(), this.DATE_TIME_FORMAT).toDate();
      var time = nextAuthEventTime.getTime() - this.now.getTime();
      this.authenticationNumberService.setAuthenticationTimeout(username, time);
    }
  }
}
